import { SaveButton } from "components/Buttons"
import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Row, Col } from "reactstrap"
import {
  getFeatureResponsesByUser,
  resetFeatureResponsesByUser,
} from "store/actions"
import { getUpdatedCheckedItemsList } from "utils"
import pollResponsesListColumns from "./Polls/pollResponsesListColumn"
import XLSX from "xlsx"

const FeatureResponsesModal = ({
  getFeatureResponsesByUser,
  resetFeatureResponsesByUser,
  featureResponsesByUser,
  featureType,
  featureId,
  answerId,
  question,
  answer,
  history,
  handleClose,
}) => {
  useEffect(() => {
    return () => {
      resetFeatureResponsesByUser()
    }
  }, [])

  useEffect(() => {
    if (featureId && answerId) {
      getFeatureResponsesByUser({
        feature: featureType,
        page: 1,
        per_page: 50,
        feature_id: featureId,
        answer_id: answerId,
        od: "desc",
      })
    }
  }, [featureId, answerId])

  const [checkedItems, setCheckedItems] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedVisitors, setSelectedVisitors] = useState([])

  const handleCheckItem = (item, checked) => {
    if (checked) {
      if (
        !item?.guest_id &&
        item?.user_id &&
        selectedUsers?.indexOf(item?.user_id) === -1
      ) {
        setSelectedUsers([...selectedUsers, item?.user_id])
      }

      if (item?.guest_id && selectedVisitors?.indexOf(item?.guest_id) === -1) {
        setSelectedVisitors([...selectedVisitors, item?.guest_id])
      }
    } else {
      if (item?.guest_id) {
        let arr = [...selectedVisitors]
        arr?.splice(arr?.indexOf(item?.guest_id), 1)
        setSelectedVisitors(arr)
      } else {
        let arr = [...selectedUsers]
        arr?.splice(arr?.indexOf(item?.user_id), 1)
        setSelectedUsers(arr)
      }
    }

    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = []
    let visitors = []
    let users = []
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i]?.user_id && !items[i]?.guest_id) {
          users.push(items[i]?.user_id)
        }
        if (items[i]?.guest_id) {
          visitors.push(items[i].guest_id)
        }
        list.push(items[i].id)
      }
    }
    setSelectedUsers(users)
    setSelectedVisitors(visitors)
    setCheckedItems(list)
  }

  const handlePageChange = page => {
    getFeatureResponsesByUser({
      feature: featureType,
      page: page,
      per_page: 15,
      feature_id: featureId,
      answer_id: answerId,
      od: "desc",
    })
    setCurrentPage(page)
    setCheckedItems([])
    setSelectedUsers([])
    setSelectedVisitors([])
  }

  const onDownloadList = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      featureResponsesByUser?.data?.map(item => {
        return {
          ["Date Created"]: item?.responded_at?.date,
          Name: item?.name,
          Email: item?.email,
          [`${item?.question}`]: item?.response,
        }
      })
    )
    const csv = XLSX.utils.sheet_to_csv(worksheet, {
      strip: true,
      blankrows: true,
      skipHidden: true,
    })
    saveAs(
      new Blob([csv], { type: "text/plain;charset=utf-8" }),
      "Poll report.csv"
    )
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <label>Question: </label>
          <span> {question}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Answer: </label>
          <span> {answer}</span>
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col>
          <Row>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Send Email"
                disabled={selectedUsers?.length === 0}
                onClick={() => {
                  localStorage.setItem(
                    "commUsers",
                    JSON.stringify(selectedUsers)
                  )
                  handleClose()
                  history.push(`/add-custom-email`)
                }}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Send Notification"
                disabled={
                  selectedUsers?.length === 0 && selectedVisitors?.length === 0
                }
                onClick={() => {
                  localStorage.setItem(
                    "commUsers",
                    JSON.stringify(selectedUsers)
                  )
                  handleClose()
                  history.push(`/add-notification`)
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col xs="auto">
          <Row>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Download Report"
                onClick={onDownloadList}
                disabled={featureResponsesByUser?.data?.length === 0}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <TableComponent
            data={featureResponsesByUser?.data?.map((x, i) => ({
              ...x,
              id: i + 1,
            }))}
            columns={pollResponsesListColumns({ displayAnswersColumn: false })}
            withCheckboxes={true}
            onCheckItem={handleCheckItem}
            onCheckAllItems={handleCheckAllItems}
            paginationData={{
              current_page: featureResponsesByUser?.current_page,
              last_page: featureResponsesByUser?.last_page,
              total_items: featureResponsesByUser?.total,
              items_per_page: featureResponsesByUser?.per_page,
              from: featureResponsesByUser?.from,
              to: featureResponsesByUser?.to,
              first_page: 1,
            }}
            onPageChange={handlePageChange}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  featureResponsesByUser: state.Analytics.featureResponsesByUser,
})

const mapDispatchToProps = dispatch => ({
  getFeatureResponsesByUser: values =>
    dispatch(getFeatureResponsesByUser(values)),
  resetFeatureResponsesByUser: () => dispatch(resetFeatureResponsesByUser()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FeatureResponsesModal))
